import { render, staticRenderFns } from "./ProductSelectSegment.vue?vue&type=template&id=1b1e6f64&"
import script from "./ProductSelectSegment.vue?vue&type=script&lang=js&"
export * from "./ProductSelectSegment.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports